module.exports = __webpack_public_path__ + "img/bekasi.348408d6.svg";